<template>
  <section class="stats-section" :style="section.config.style">
    <div class="container">
      <div class="section-title" v-if="section.config.title">
        <h2>{{ section.config.title }}</h2>
        <p v-if="section.config.subtitle">{{ section.config.subtitle }}</p>
      </div>
      
      <div class="stats-grid" :class="[`layout-${section.config.layout}`]">
        <div 
          v-for="stat in section.config.stats" 
          :key="stat.id"
          class="stat-item"
          :style="{ '--stat-color': stat.color }"
        >
          <div class="stat-icon" v-if="stat.icon">{{ stat.icon }}</div>
          <div class="stat-number">{{ stat.number }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StatsSection',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.stats-section {
  padding: 60px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
}

.section-title p {
  font-size: 1.125rem;
  color: var(--gray-600);
}

.stats-grid {
  display: grid;
  gap: 2rem;
}

.layout-horizontal {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.layout-grid {
  grid-template-columns: repeat(2, 1fr);
}

.layout-vertical {
  grid-template-columns: 1fr;
}

.stat-item {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  transition: all 0.3s ease;
  border-top: 4px solid var(--stat-color, var(--primary-color));
}

.stat-item:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.stat-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--stat-color, var(--primary-color));
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
  color: var(--gray-600);
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .layout-horizontal,
  .layout-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .stat-item {
    padding: 1.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .layout-horizontal,
  .layout-grid {
    grid-template-columns: 1fr;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/StatsSection.vue